import * as React from "react";
function SvgDownloadExam(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.646 2.784A.481.481 0 014 2.625h8.857c.133 0 .26.057.354.159l2.393 2.592c.093.102.146.24.146.383v2.147c0 .449.336.813.75.813s.75-.364.75-.813V5.758c0-.574-.21-1.125-.585-1.53L14.27 1.633A1.925 1.925 0 0012.857 1H4c-.53 0-1.04.228-1.414.635A2.262 2.262 0 002 3.167v14.896c0 .574.21 1.125.586 1.532.375.406.884.634 1.414.634h4.375c.414 0 .75-.364.75-.812 0-.45-.336-.813-.75-.813H4a.481.481 0 01-.354-.159.565.565 0 01-.146-.383V3.168c0-.144.053-.282.146-.383zM5.25 6.417c-.414 0-.75.363-.75.812 0 .449.336.813.75.813H14c.414 0 .75-.364.75-.813 0-.449-.336-.812-.75-.812H5.25zm0 4.062c-.414 0-.75.364-.75.813 0 .448.336.812.75.812h5c.414 0 .75-.364.75-.812 0-.449-.336-.813-.75-.813h-5zm-.75 4.875c0-.448.336-.812.75-.812h3.125c.414 0 .75.364.75.812 0 .449-.336.813-.75.813H5.25c-.414 0-.75-.364-.75-.813zM17.25 14c0-.449-.336-.813-.75-.813s-.75.364-.75.813v3.455l-.595-.644a.71.71 0 00-1.06 0 .861.861 0 000 1.149l1.875 2.031a.743.743 0 00.478.236.702.702 0 00.318-.05c.096-.04.185-.1.263-.184l.001-.002 1.875-2.031a.861.861 0 000-1.15.71.71 0 00-1.06 0l-.595.645V14zm-.75-1.896c-2.347 0-4.25 2.062-4.25 4.604 0 2.543 1.903 4.605 4.25 4.605s4.25-2.062 4.25-4.605c0-2.542-1.903-4.604-4.25-4.604zm-5.75 4.604c0-3.44 2.574-6.229 5.75-6.229s5.75 2.79 5.75 6.23c0 3.44-2.574 6.229-5.75 6.229s-5.75-2.79-5.75-6.23z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgDownloadExam);
export default ForwardRef;
